import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  apiKey,
  enableSpotVolume,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey, enableSpotVolume] as const
const locationCredentialTypes = ['location-api-key'] as const

export type abfsCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const abfsDocumentTypes = [
  'authorization-for-special-service',
  'contact-time-critical',
  'corrected-bol',
  'customs-documents',
  'delivery-photo',
  'dimension-certificate',
  'freight-forwarding-delivery-order',
  'invoice',
  'packing-slip',
  'proof-of-delivery',
  'reconsignment-authorization',
  'refused-delivery-receipt',
  'signed-bol',
  'tally-record-signature',
  'weight-and-research-inspection',
  'weight-cert',
  'weights-and-research-photos',
] as const satisfies readonly DocumentType[]

export const abfs: CarrierDef<abfsCredType> = {
  name: 'ABF Freight System',
  scac: 'abfs',
  credentialTypes,
  locationCredentialTypes,
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Time-Critical Guaranteed by 5:00pm',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Time-Critical Guaranteed by 12:00pm',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    { id: 'volume', name: 'Volume' },
  ],
  legacyCredMap: [
    ['api-key', 'apiKey'],
    ['location-api-key', 'ref1'],
    ['enable-spot-volume-rates', 'enableSpotVolumeRates'],
    ...userPassMap,
  ],
  credentialConfig: {
    'enable-spot-volume-rates': {
      type: 'checkbox',
    },
  },
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'documents',
    'tracking',
  ],
  documentTypes: abfsDocumentTypes,
}
